import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValuesShipment, schema, additionalState, parseData } from './config';

import Sidebar from './Components/Sidebar';

import useIsMobile from '../../hooks/useIsMobile';


const EditShipment = () => {
  let { isMobile } = useIsMobile();
  let sidebar = isMobile ? null : <Sidebar />;
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  return (
    <EditForm title={"Shipment"} initialValues={initialValuesShipment} fields={formFields} schema={schema} url={"shipments"} additionalState={additionalState} sidebar={sidebar} parseData={parseData}>
      
     </EditForm>
  );
}

export default EditShipment;